import React, { useState, useEffect } from 'react';
import useTranslations from '../../utils/useTranslations';
import adFreeButton from '../../images/prodnews/bt_adfree_button.png';
import googlePlayButton from '../../images/prodnews/google-play.png';
import ChimpForm from '../../components/chimpForm';
import { Link } from 'gatsby';
import { getBaiAdStyle } from '../../utils/baiAd';
import Seo from '../../components/seo';
const brand = process.env.BRAND === 'bt' ? 'bt' : 'ut';

const ProdNews = (props) => {
    const { text, locale } = props.pageContext;
    const t = useTranslations(text);

    const [isMac, setIsMac] = useState(false);

    let catLink = locale
        ? `url(/images/${brand}/pro-free-trial/cat-14days-${locale}.png)`
        : `url(/images/${brand}/pro-free-trial/cat-14days-en.png)`;
    const baiStyle = getBaiAdStyle(locale, '300x600', '300/600', {
        width: '100%',
        display: 'block',
        height: '100%',
    });

    let adBg = {
        background: catLink,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
    };

    useEffect(() => {
        if (window.gatsbyIsMac) {
            setIsMac(true);
        }
    }, []);

    return (
        <div className="prodnews-container w-100 d-flex">
            <div className="container align-self-center prodnews-inner-container my-5">
                <div className="row text-center text-white flex-lg-nowrap justify-content-center">
                    <div className="col-9">
                        <div className="row">
                            <div className="col-12">
                                <p style={font.lg} className="font-weight-bold mb-3">
                                    {t(`You've just been upgraded to the latest version of $brand!`)}
                                </p>
                                <p className="mb-1">
                                    {t(`Every few weeks, we release a new version with improvements`)}
                                </p>
                                <p className="mb-0">
                                    Read the blog post for what's{' '}
                                    <Link
                                        className="text-primary font-weight-bold"
                                        to={`/blog/releases/${isMac ? 'mac' : 'windows'}/`}
                                        id={`prodnews-releasenotes-${isMac ? 'mac' : 'windows'}`}
                                    >
                                        new in this version.
                                    </Link>
                                </p>
                            </div>
                        </div>
                        <div className="row my-5 justify-content-center">
                            {isMac && (
                                <div className="offset-1 col-10 bg-dark p-5 rounded">
                                    <p className="text-white" style={font.md}>
                                        {t(`Get $brand news update and special offers!`)}
                                    </p>

                                    <ChimpForm
                                        id="prodnews-mailchimp"
                                        list="https://bittorrent.us5.list-manage.com/subscribe/post?u=a3baea4e54ff8e8b235488c11&amp;id=159eb566c6"
                                        classButton="prodnews-button"
                                    />

                                    <p className="text-white">
                                        By signing up, you agree to our{' '}
                                        <Link
                                            to="/legal/privacy-policy"
                                            id="prodnews-privacylink"
                                            className="text-primary font-weight-bold"
                                        >
                                            Privacy Policy
                                        </Link>
                                    </p>
                                </div>
                            )}
                            {!isMac && (
                                <a
                                    id="prodnews-pro-free-trial"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://store.bittorrent.com/849/purl-btprotrialweb14"
                                    style={{ ...adStyle.a, ...adBg }}
                                ></a>
                            )}
                        </div>
                        <div className="row">
                            <div className="col-8 offset-2">
                                <div className="row">
                                    <div className="col-12 col-md-6 d-inline-block">
                                        <a
                                            id="prodnews-go-adfree-img"
                                            href="https://store.bittorrent.com/b_c_af_w?x-source=bts"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={adFreeButton} alt="ad free button" />
                                        </a>
                                        <p className="mt-3 mb-0">{t(`Try $brand without ads!`)}</p>
                                        <a
                                            id="prodnews-go-adfree-textlink"
                                            className="text-primary font-weight-bold"
                                            href="https://store.bittorrent.com/b_c_af_w?x-source=bts"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {t(`Go ad-free`)}
                                        </a>
                                    </div>
                                    <div className="col-12 col-md-6 d-inline-block">
                                        <a
                                            id="get-android-img"
                                            href="https://play.google.com/store/apps/details?id=com.bittorrent.client&referrer=utm_source%3Dclient%26utm_medium%3Dweb%26utm_term%3Dprodnews%26utm_campaign%3Dprodnews"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={googlePlayButton}
                                                alt="Google Play button for BitTorrent Android"
                                            />
                                        </a>
                                        <p className="mt-3 mb-0">{t(`Get the Android mobile app.`)}</p>
                                        <a
                                            id="get-android-textlink"
                                            className="text-primary font-weight-bold"
                                            href="https://play.google.com/store/apps/details?id=com.bittorrent.client&referrer=utm_source%3Dclient%26utm_medium%3Dweb%26utm_term%3Dprodnews%26utm_campaign%3Dprodnews"
                                            rel="noopener noreferrer"
                                        >
                                            On Google Play
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-3 d-flex align-items-center justify-content-center">
                        <a
                            id="prodnews-bai-ad"
                            href="https://chat.b.ai/chat?utm_source=bt"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={baiStyle}
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProdNews;

const adStyle = {
    a: {
        display: 'block',
        height: '349px',
        width: '420px',
    },
};
const font = {
    lg: {
        fontSize: '26px',
    },
    md: {
        fontSize: '20px',
    },
};

export const Head = ({ pageContext }) => <Seo pageContext={pageContext} />;
